import React from 'react';
import Grid from '@mui/material/Grid';
import { SplashBackground } from 'assets/imagesList';

export default function SignInUpContainer(props) {
  const { children } = props;

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Grid
        item
        height="100vh"
        width="100%"
        style={{
          backgroundImage:
            'linear-gradient(rgb(88, 22, 105), rgb(3, 159, 188) 60%, rgb(169, 235, 222) 100%)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          textAlign: 'center',
          color: 'black',
          backgroundBlendMode: 'multiply',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            top: '25%',
            position: 'fixed',
            left: '0px',
            right: '0px',
            bottom: '0px',
          }}
        >
          <img src={SplashBackground} width="100%" height="100%" />
        </div>
        {children}
      </Grid>
    </Grid>
  );
}
